export { default } from './MaxVatExposureDisplayContainer'
